import React from "react";
import "./Feedback.css";

const defaultMessages = {
  success: {
    icon: "bi bi-check-circle-fill",
    title: "Success",
    message: "Action completed successfully.",
  },
  error: {
    icon: "bi bi-x-circle-fill",
    title: "Error",
    message: "Something went wrong. Please try again.",
  },
  login: {
    icon: "bi bi-exclamation-triangle-fill",
    title: "Login Required",
    message: "Please log in to continue.",
  },
};

function Feedback({
  isOpen,
  type = "success", // success | error | login
  title,
  message,
  onClose,
}) {
  if (!isOpen) return null;

  const data = {
    ...defaultMessages[type],
    title: title || defaultMessages[type].title,
    message: message || defaultMessages[type].message,
  };

  return (
    <div className="modal-overlay">
      <div className="delete-modal">

        <h2>{data.title}</h2>
        <p>{data.message}</p>

<div className="modal-actions">
        <button className="delete_approve_btn" onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
}

export default Feedback;
